import { Link } from "react-router-dom";

import { Footer } from "@/components/layout/Footer";
import { Header } from "@/components/layout/Header";

export function NotFound() {
  return (
    <div className="flex min-h-screen flex-col bg-bg text-ink">
      <Header />
      <main className="flex flex-1 items-center justify-center px-4 py-20 sm:px-6">
        <div className="max-w-md text-center">
          <p className="eyebrow">404</p>
          <h1 className="s-title mt-3">We can&apos;t find that page.</h1>
          <p className="s-sub mt-4">
            The link may be old or mistyped. The home page is a good place to start.
          </p>
          <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
            <Link to="/" className="btn-indigo">
              Go home
            </Link>
            <Link to="/help" className="btn-glass">
              Help center
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
